<template>
<div style="height:100%">
  <div id="csContainer">
    <el-select  class="viewChange" size="small" v-model="value" clearable placeholder="视角切换">
        <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
        </el-option>
    </el-select>
<!--      <el-button class="get" size="small" type="primary" @click="getCamera()">相机位置姿态</el-button>-->

  </div>
  <div id="loadingOverlay"><h1>Loading........</h1></div>
</div>
</template>


<script>
    /*eslint-disable*/
    import * as Cesium from "cesium/Cesium";
    import widgets from "cesium/Widgets/widgets.css";
    import util from "../../components/util"
    export default {
        name: 'viewChange',
        data(){
            return{
                viewer: null,
                options: [{
                    value: 'front',
                    label: '平视'
                }, {
                    value: 'overlook',
                    label: '俯视'
                }, {
                    value: 'flyto',
                    label: '飞到物体'
                }, ],
                value: ''
            }
        },
        mounted(){
            var loa=document.getElementById('loadingOverlay');
        setTimeout(()=>{
           loa.style.display="none";
       },4000);
            this.init();
        },
        watch:{
            value:function (val) {
                if(val === "front"){
                    // let  cf = new Cesium.Cartesian3(1213921.3451617535, -4737665.442233561, 4080427.1750805615);
                    // let hpr = new Cesium.HeadingPitchRoll(-38.43334589880898 , -9.300214509956538
                    //     , -41.463119553442205);
                    // let orientation = Cesium.Transforms.headingPitchRollQuaternion(cf, hpr);
                    // this.viewer.camera.flyTo({
                    //     destination :cf,
                    //     orientation : orientation
                    // });
                    let  cf = new Cesium.Cartesian3(1213947.5968302155, -4737662.283311761, 4080375.7916036425)   ;

                    this.viewer.camera.flyTo({
                        destination :cf,
                        orientation : {
                            heading : 4.720808451716874,
                            pitch : 0.021255177178900908,
                            roll : 6.279880946163079
                        }
                    });

                }else if(val === "overlook"){
                    this.viewer.camera.flyTo({
                        destination : Cesium.Cartesian3.fromDegrees(-75.62898254394531, 40.02804946899414, 100.0),
                        orientation : {
                            heading : Cesium.Math.toRadians(0),
                            pitch : Cesium.Math.toRadians(-90),
                            roll : 0.0
                        }
                    });
                }else if(val === "flyto"){
                    let  cf = new Cesium.Cartesian3(1213913.4690678618, -4737658.327289971, 4080425.1851585475)  ;

                    this.viewer.camera.flyTo({
                        destination :cf,
                        orientation : {
                            heading : 3.8527450463343214,
                            pitch : -0.551813136235094,
                            roll : 6.280709484288032
                        }
                    });
                }
            }
        },
        methods:{
            init(){
                this.viewer= util.getViewer("csContainer");
                let viewer = this.viewer;
                this.modelMatrix = Cesium.Transforms.eastNorthUpToFixedFrame(Cesium.Cartesian3.fromDegrees(-75.62898254394531, 40.02804946899414, 0.0));

                this.model = viewer.scene.primitives.add(Cesium.Model.fromGltf({
                    url : "/demo/static/data/models/car.glb",
                    modelMatrix : this.modelMatrix,
                    scale : 2
                }));
                viewer.camera.setView({
                    destination : Cesium.Cartesian3.fromDegrees(-75.62898254394531, 40.02804946899414, 300.0),
                    orientation : {
                        heading : Cesium.Math.toRadians(-35),
                        pitch : Cesium.Math.toRadians(-85),
                        roll : 12
                    }
                });

            },
            getCamera(){
                let destination = this.viewer.camera.positionWC;
                // let destination = Cesium.Cartesian3.fromDegrees(-75.62898254394531, 40.02804946899414, 300.0);
                // let direction = this.viewer.camera.directionWC  ;
                //
                //
                // let x = Cesium.Math.toDegrees(direction.x);
                // let y = Cesium.Math.toDegrees(direction.y);
                // let z = Cesium.Math.toDegrees(direction.z);

                let x = Cesium.Math.toDegrees(this.viewer.camera.heading);
                let y = Cesium.Math.toDegrees(this.viewer.camera.pitch);
                let z = Cesium.Math.toDegrees(this.viewer.camera.roll);


                let result = '世界坐标系位置' + destination + '\n'+
                    '偏航角：'+ x +'°'+'\r' +  '俯仰角：' + y +'°' +'\r' + '翻滚角：'+ z +'°';
                // let result = '世界坐标系位置' + destination + '\n'+
                //     x +','  + y +',' + z;
                this.$alert(result , '相机位置姿态', {
                    confirmButtonText: '确定',

                });
            }

        }
    }
</script>
<style scoped>
  .viewChange {
    position: absolute;
    width:120px;
    margin-left: 25px;
    margin-top:7px;
    z-index: 999;
  }
  .get{
      position: absolute;
      width:150px;
      margin-left: 185px;
      margin-top:7px;
      z-index: 999;
  }

  #csContainer {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
  }
</style>
